module.exports = __webpack_public_path__ + "static/media/complete-ci.223fb5d4.svg";